import React, { FC, ReactNode } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type HeaderProps = StylableComponent<HTMLDivElement> & {
  left: ReactNode;
  right: ReactNode;
};

const Header: FC<HeaderProps> = ({
  className,
  style,
  children,
  left,
  right,
}) => {
  return (
    <Flex
      className={className}
      alignItems="center"
      justifyContent="space-between"
      padding="8px"
      width="100%"
      height="48px"
      borderBottom={`1px solid ${theme.colors.charcoal200}`}
      style={style}
    >
      <Flex alignItems="center" justifyContent="start" flex={1}>
        {left}
      </Flex>

      {children}

      <Flex alignItems="center">{right}</Flex>
    </Flex>
  );
};

Header.displayName = 'Header';

export default WithAlloySuspense(Header);
